module.exports = __webpack_public_path__ + "img/three2Blue.026e759d.jpg";